module.exports = __webpack_public_path__ + "static/media/logo-mirewards-reversed.3df31071.svg";